module.exports = __webpack_public_path__ + "static/media/cloud-hail.f4ea92fa.svg";